import React from 'react';
import SideList from 'partial/wrappers/SideList';
import { useActiveAccount } from 'modules/auth/hooks';
import NavTab, { NavTabItem } from 'partial/components/NavTab';
import { useRouteMatch, Switch, Route, Redirect } from 'react-router-dom';
import AuthStore from 'auth-store';

import Cashback from 'core-modules/cashback/containers/Cashback';
// import TransactionTable from 'core-modules/dashboard/components/TransactionTable';
// import ApiKeysContainer from 'core-modules/developers/containers/ApiKeysContainer';
// import IntegrationDashboard from 'core-modules/developers/containers/IntegrationDashboard';
import OnboardingContainer from 'core-modules/merchant-onboarding/containers/OnboardingContainer';
// import AclUsers from 'core-modules/users/containers/AclUsers';
// import InvoiceRoutes from 'core-modules/invoice/containers/InvoiceRoutes';

import { useMerchantSelected } from '../hooks';
// import MerchantDashboard from './MerchantDashboard';
import MerchantList from '../components/MerchantList';
import MerchantHeader from '../components/MerchantHeader';
import MerchantDetail from '../components/MerchantDetail';
import BillerProfile from './BillerProfile';
// import MerchantChannels from '../components/MerchantChannels';

function MerchantProfile() {
  const [activeAccount] = useActiveAccount();
  const userRole = AuthStore.get('_role');
  const renderList = React.useCallback(
    (selected, onSelect) => (
      <MerchantList
        onSelect={onSelect}
        selected={selected}
        add={userRole === 'organization'}
      />
    ),
    [userRole]
  );
  const match = useRouteMatch();
  const [isLoading, data] = useMerchantSelected();

  if (userRole === 'biller')
    return (
      <BillerProfile
        data={data}
        isLoading={isLoading}
        activeAccount={activeAccount}
      />
    );

  return (
    <SideList id="merchant-profile" renderList={renderList}>
      <div className="bg-white h-full flex flex-col rounded-xl">
        <MerchantHeader
          data={data}
          isLoading={isLoading}
          readOnly // TODO
        />
        <div className="border-b border-gray-200 mb-2">
          <NavTab>
            {/* <NavTabItem to={`${match.url}/dashboard`} label="Dashboard" /> */}
            {data.approval_status === 'APPROVED' ? (
              <>
                <NavTabItem to={`${match.url}/details`} label="Profile" />
                <NavTabItem to={`${match.url}/cashback`} label="Cashback" />
              </>
            ) : (
              <>
                {activeAccount?.role !== 'DEV' ? (
                  <NavTabItem to={`${match.url}/kyc`} label="KYC" />
                ) : null}
              </>
            )}
            {/* <NavTabItem to={`${match.url}/transactions`} label="Transactions" /> */}
            {/* {activeAccount?.role !== 'DEV' ? (
              <NavTabItem to={`${match.url}/channels`} label="Channels" />
            ) : null} */}

            {/* <NavTabItem to={`${match.url}/invoice`} label="Invoice" /> */}
            {/* {activeAccount?.role !== 'BUSINESS' ? (
              <NavTabItem to={`${match.url}/integration`} label="Integration" />
            ) : null} */}
            {/* {activeAccount?.role === 'OWNER' ? (
              <NavTabItem to={`${match.url}/users`} label="Users" />
            ) : null} */}
          </NavTab>
        </div>
        {data.id ? (
          <div className="overflow-y-auto px-4 mt-4 pb-8 sm:px-6 lg:px-8 flex-1 flex flex-col container mx-auto">
            <Switch>
              {/* <Route
                path={`${match.path}/dashboard`}
                component={MerchantDashboard}
              /> */}
              <Route path={`${match.path}/details`}>
                {data.approval_status !== 'APPROVED' ? (
                  <Redirect to={`${match.path}/kyc`} />
                ) : (
                  <MerchantDetail data={data} />
                )}
              </Route>
              <Route path={`${match.path}/cashback`} component={Cashback} />
              {/* <Route path={`${match.path}/integration`}>
                <div className="space-y-4">
                  <IntegrationDashboard merchant={data} />
                  <ApiKeysContainer />
                </div>
              </Route> */}
              {/* <Route
                path={`${match.path}/transactions`}
                component={TransactionTable}
              />
              <Route path={`${match.path}/channels`}>
                <MerchantChannels merchantId={data?.id} />
              </Route> */}
              <Route path={`${match.path}/kyc`}>
                {data.approval_status === 'APPROVED' ? (
                  <Redirect to={`${match.path}/details`} />
                ) : (
                  <OnboardingContainer key={data?.id} merchant={data} />
                )}
              </Route>
              {/* <Route path={`${match.path}/invoice`} component={InvoiceRoutes} />
              {/* <Route path={`${match.path}/users`} component={AclUsers} /> */}
              {/* <Redirect to={`${match.url}/dashboard`} /> */}
              <Redirect to={`${match.url}/details`} />
            </Switch>
          </div>
        ) : null}
      </div>
    </SideList>
  );
}

MerchantProfile.propTypes = {};

export default MerchantProfile;
